module.exports = __webpack_public_path__ + "img/headerImg.69311832.png";